import { useEffect, useState } from 'react';
import { modelsAPI } from './api';
import { MODELLI } from '../data/modelli';

let cache = null;
let inflight = null;
const listeners = new Set();

const notify = () => listeners.forEach(fn => fn(cache));

export const loadModels = async (force = false) => {
    if (cache && !force) return cache;
    if (!inflight) {
        inflight = modelsAPI.getAll()
            .then(res => { cache = res.data || []; notify(); return cache; })
            .catch(() => { cache = cache || MODELLI.map(n => ({ id: n, name: n })); notify(); return cache; })
            .finally(() => { inflight = null; });
    }
    return inflight;
};

export const invalidateModels = () => loadModels(true);

// Lista modelli condivisa (API con fallback alla lista statica)
export const useModelList = () => {
    const [models, setModels] = useState(cache || []);
    useEffect(() => {
        listeners.add(setModels);
        loadModels();
        return () => listeners.delete(setModels);
    }, []);
    return models;
};
